import React, { useState } from 'react'
import leftarrow from "../../../assets/images/left-arrow.svg";
import eyeiconunfold from "../../../assets/images/eyeiconunfold.svg";
import eyeIcon from "../../../assets/images/eyeicon.svg";
import ResetPassJson from "./otpLogin.json";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import styles from './otpLogin.module.css';
import { Timer } from '../timer/timer';
import { Footer } from '../../common/footer/footer';
const NewPaawordJsx = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  let {
    formData,
    onInputChangeHandler,
    timerStart,
    onTimerComplete,
    onResendOTPClick,
    onTouchHandler,

    formError,
    formSubmitHandler,
  } = props;
  const [showPassword, setShowPassword] = useState({});
  const flowType = localStorage.getItem("flowType");
  const toggleShowPassword = (fieldName) => {
    setShowPassword(prevState => ({
      ...prevState,
      [fieldName]: !prevState[fieldName]
    }));
  };
  return (
    <>
      <section className="mainloginscreen">
        <div className="container">
          <div className={`${styles.mainloginscreeninner}`}>
            <div className={`${styles.leftsightbackdetails} d-flex`}>

              <div className="detailsleft plaindetailsleft align-items-center justify-content-center">
                <div className="back_btn" onClick={() => history.goBack()}><img src={leftarrow} alt={'icon'} /></div>
                <h1>{t("LOGIN.OTP")}</h1>

              </div>
            </div>
          </div>
          <div className={`${styles.formsection}`}>
            <div className={`${styles.institutelogintext}`}>
              <div className="passtext">
                <h4 className="italic h4_style color-light-blue">{t("LOGIN.OTP_TAGLINE")} </h4>
              </div>

              <div className={`${styles.institutelogininner} forgetpassinner`}>

                <div className={`${styles.ft_inner} otpauthentication`}>
                  {ResetPassJson.map((item, i) => (
                    <>
                      <div className={`input-container form-group ${styles.formfield}`}>
                        <label>{t(`${item.label}`)}</label>
                        <input
                          type={showPassword[item.name] ? "text" : "password"}
                          className={
                            item.isRequired && formError[item.name]
                              ? `input form-control  is-invalid email-input-${flowType}`
                              : `input form-control email-input-${flowType}`
                          }
                          id={item.name}
                          name={item.name}
                          placeholder={t(`${item.label}`)}
                          defaultValue={formData[item.name]}
                          onChange={onInputChangeHandler}
                          onBlur={onTouchHandler}
                          maxLength={item.maxLength}
                        />
                        <div className={`${styles.form_image} email-image-${flowType}`} onClick={() => toggleShowPassword(item.name)}>
                          {
                            showPassword[item.name] ? (
                              <img alt="Hide password" src={eyeiconunfold} />
                            ) : (
                              <img alt="Show password" src={eyeIcon} />
                            )
                          }
                        </div>
                        <span className="h6 text-danger">
                          {item.isRequired &&
                            formError[item.name] &&
                            (formError[item.name] === "req"
                              ? t(item.error)
                              : (formError[item.name] === "regx") ? t(item.type_error) : "Password did not match")}
                        </span>
                      </div>

                    </>
                  ))}
                  <h5 className={`${styles.small}`}>{t("LOGIN.JUNK_FOLDER_WARNING")}</h5>
                  <button type="submit" className={
                    !formData.newpassword
                      ? "mt-4 ctatwobutton mb-3"
                      : "mt-4 ctaonebutton mb-3"
                  } onClick={formSubmitHandler} disabled={!formData.newpassword}>{t("COMMON.CONTINUE")}</button>
              {
                     
                    timerStart ? <div className="otptimets"><Timer show={timerStart} onCompletion={() => onTimerComplete()} /></div>
                      :
                      <div className="otptime text-right" onClick={onResendOTPClick}> {t("PASSWORDAUTHORIZATION.RESENDOTP")}</div>
                 
                  }


                </div>
              </div>

            </div>
          </div>

          <Footer />
        </div>
      </section>
      <ToastContainer />


    </>

  );
};

export default NewPaawordJsx;
